import { render, staticRenderFns } from "./ImageCropper.vue?vue&type=template&id=64b49a10&scoped=true"
import script from "./ImageCropper.vue?vue&type=script&lang=js"
export * from "./ImageCropper.vue?vue&type=script&lang=js"
import style0 from "./ImageCropper.vue?vue&type=style&index=0&id=64b49a10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b49a10",
  null
  
)

export default component.exports